export class CartaCreditoEmitidaVO {

  cnpj: string;
  razaoSocial: string;
  periodo: string;
  nrAnoBase: number;
  total: number;
  situacao: string;
}
